import { Todo, WorkItemType } from "./WorkItem"
import { Export } from "@fusion-advantage/backcompat"

// used when we have a local today Appt draft not sync'd to the server
// and we need to temporarily show a Todo for it
export const expToDraftTodo = (exp: Export): Todo => {
	return {
		WorkItemType: WorkItemType.Todo,
		MemberGUID: exp.Form.Member.Member_GUID,
		MemberName: exp.Form.Member.MemberName,
		EncounterGUID: exp.Form.Encounter.Encounter_GUID,
		CodeNext: exp.Form.Encounter.CodeNext,
		// on a local draft this should have been filled in by appFormLoad
		// however, since that attribute is technically nullable...
		CreatedOn: exp.Form.Encounter.DateOfService ?? null,
		ReadOnly: false,
	}
}
